import { flexRoot, center } from 'csstips';
import { px } from 'csx';
import React from 'react';
import { style } from 'typestyle';
import { rebrand } from '../../../theme/color';
import { spacing } from '../../../theme/spacing';
import { Checkmark } from '../atoms/icons/Checkmark';
import { CloseCross } from '../atoms/icons/CloseCross';

interface VideoPlatformProps {
  name: string;
  allowed: boolean;
}

const styles = {
  platform: style(flexRoot, center, {
    fontSize: px(12),
    padding: 0,
    gap: spacing.XXSMALL,
  }),
};

const PLATFORM_NAMES = {
  youtube: 'YouTube',
  dailymotion: 'DailyMotion',
  linkedin: 'LinkedIn',
};

const toUpperFirst = (str: string) => str[0].toUpperCase() + str.slice(1);

const formatPlatform = (platformName: string) => PLATFORM_NAMES[platformName] || toUpperFirst(platformName);

export const VideoPlatform: React.FC<VideoPlatformProps> = ({ name, allowed }) => {
  return (
    <li className={styles.platform}>
      {allowed ? (
        <Checkmark color={rebrand.secondary[70].toHexString()} size={16} />
      ) : (
        <CloseCross size={16} color={rebrand.semantic.error[70].toHexString()} />
      )}
      <span>{formatPlatform(name)}</span>
    </li>
  );
};
